import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IShippingSearchDownload, ShippingReport, ShippingSearch, ShippingSearchDownload } from '@core/models';
import { Store } from '@ngrx/store';
import { Observable, firstValueFrom } from 'rxjs';
import {
  loadShippingSearch,
  loadShippingSearchDownloads,
  saveShippingReport,
  saveShippingSearch,
  setShippingSearchDownloadsSortOrder,
  unloadShippingReport
} from '../store/actions/order.actions';
import { AppState } from '../store/reducers/index';
import { ConfigService } from './config.service';

@Injectable()
export class OrdersService {

  baseOrderPath: string;
  payerPortalPath: string;

  baseOrderPathOnSite: string;
  reportUrl: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient,
    private readonly store: Store<AppState>) {
    this.baseOrderPath = `${this.configService.appConfig.api.orderUrl}`;
    this.payerPortalPath = `${this.configService.appConfig.api.baseUrl}`;
    this.reportUrl = `${this.configService.appConfig.api.reportUrl}`
  }

  shippingSearchDownloadFactory(downloadData: IShippingSearchDownload): ShippingSearchDownload {
    return new ShippingSearchDownload(downloadData);
  }

  shippingSearch(shippingSearchData: any): Promise<any> {
    return firstValueFrom(this.httpClient.post(`${this.baseOrderPath}/shipping`, shippingSearchData, { observe: 'response' }));
  }

  shippingSearchDownload(shippingSearchData: any): Promise<any> {
    return firstValueFrom(this.httpClient.post(`${this.baseOrderPath}/shipping/downloads`, shippingSearchData, { observe: 'response' }));
  }

  getShippingSearchDownloads(): Promise<ShippingSearchDownload[]> {
    return firstValueFrom(this.httpClient
      .get<IShippingSearchDownload[]>(`${this.baseOrderPath}/shipping/downloads`))
      .then(response => {
        const shippingSearchDownloads: ShippingSearchDownload[] = [];

        if (response && response.length > 0) {
          response.forEach(downloadData => {
            shippingSearchDownloads.push(this.shippingSearchDownloadFactory(downloadData));
          });
        }

        return shippingSearchDownloads;
      });
  }

  downloadShippingSearchDownload(downloadId: number): Promise<any> {
    return firstValueFrom(this.httpClient.get(`${this.configService.appConfig.api.downloadUrl}/orders/shipping/${downloadId}`, { responseType: 'blob' })).then(response => response)
      .catch(response => response);
  }

  deleteShippingSearchDownload(downloadId: number): Observable<any> {
    return this.httpClient.delete(`${this.baseOrderPath}/shipping/downloads/${downloadId}`);
  }

  getUserTrustedToken(userName: string, reportId: string): Promise<any> {
    let tokenRequest = { "userName": userName, "reportId": reportId };
    return firstValueFrom(this.httpClient.post(`${this.reportUrl}/tableau/token`, tokenRequest));
  }

  loadShippingSearch(): void {
    this.store.dispatch(loadShippingSearch());
  }

  saveShippingSearch(shippingSearch: ShippingSearch): void {
    this.store.dispatch(saveShippingSearch({ payload: shippingSearch }));
  }

  unloadShippingReport(): void {
    this.store.dispatch(unloadShippingReport());
  }

  saveShippingReport(shippingReport: ShippingReport): void {
    this.store.dispatch(saveShippingReport({ payload: shippingReport }));
  }

  loadShippingSearchDownloads(): void {
    this.store.dispatch(loadShippingSearchDownloads());
  }

  setShippingSearchDownloadsSortOrder(key: string): void {
    this.store.dispatch(setShippingSearchDownloadsSortOrder({ payload: key }));
  }

}
